<template>
	<div class="dn-layout" :class="{ 'dn-layout--collapsed': sidebarCollapsed }">
		<V2Sidebar
			:collapsed.sync="sidebarCollapsed"
			:mobile-open.sync="sidebarMobileOpen"
		/>

		<!-- Mobile overlay -->
		<div
			v-if="sidebarMobileOpen"
			class="dn-sidebar-overlay"
			@click="sidebarMobileOpen = false"
		/>

		<!-- Mobile hamburger -->
		<button
			class="dn-mobile-toggle"
			@click="sidebarMobileOpen = !sidebarMobileOpen"
		>
			<svg width="20" height="20" viewBox="0 0 20 20"><path d="M3 5H17M3 10H17M3 15H17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
		</button>

		<!-- Main content -->
		<main class="dn-page">
			<slot />
		</main>
	</div>
</template>


<script>
import V2Sidebar from '@/layouts/V2Sidebar.vue';

const STORAGE_KEY = 'v2SidebarCollapsed';

export default {
	name: 'V2Layout',

	components: {
		V2Sidebar,
	},

	data() {
		return {
			sidebarCollapsed: localStorage.getItem(STORAGE_KEY) === 'true',
			sidebarMobileOpen: false,
		};
	},

	watch: {
		sidebarCollapsed(val) {
			localStorage.setItem(STORAGE_KEY, String(val));
		},
	},
};
</script>


<style lang="sass" scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap')
@import '~@/assets/styles/v2-tokens.sass'

// ── Layout ───────────────────────────────
.dn-layout
	display: flex
	min-height: 100vh
	background: $v2-bg
	font-family: $v2-font

// ── Mobile hamburger ─────────────────────
.dn-mobile-toggle
	display: none
	position: fixed
	top: 12px
	left: 12px
	z-index: 90
	width: 36px
	height: 36px
	border: none
	border-radius: 10px
	background: $v2-card-bg
	box-shadow: $v2-shadow-card
	cursor: pointer
	align-items: center
	justify-content: center
	color: $v2-text

	@media (max-width: 768px)
		display: flex

// ── Mobile overlay ───────────────────────
.dn-sidebar-overlay
	display: none

	@media (max-width: 768px)
		display: block
		position: fixed
		inset: 0
		background: rgba(0,0,0,0.4)
		z-index: 99

// ── Page layout ──────────────────────────
.dn-page
	margin-left: $v2-sidebar-width
	width: calc(100% - #{$v2-sidebar-width})
	min-width: 0
	padding: 24px 32px
	font-family: $v2-font
	color: $v2-text
	min-height: 100vh
	transition: margin-left 0.2s ease, width 0.2s ease
	overflow-x: hidden
	box-sizing: border-box

	.dn-layout--collapsed &
		margin-left: $v2-sidebar-collapsed-width
		width: calc(100% - #{$v2-sidebar-collapsed-width})

	@media (max-width: 768px)
		margin-left: 0
		width: 100%
		padding: 56px 16px 24px
</style>
